module.exports = {
  eventType: {
    noteon: 'noteon',
    noteoff: 'noteoff',
    controller: 'cc',
    tempo: 'tempo',
    pitchbend: 'pitch',
    substitution: 'substitution',
    substitutionEnd: 'substitutionEnd',
    sustain: 'sustain',
    scale: 'scale',
    marker: 'marker'
  },
  macroType: {
    annotation: 'annotation',
    articulation: 'articulation',
    substitution: 'substitution',
    animation: 'animation',
    constraint: 'constraint'
  },
  modifierType: {
    pitch: 'pitch'
  }
};


// WEBPACK FOOTER //
// ./src/interpreter/constants.js